import * as React from 'react'

const Condition = () => {
  return <></>
}

export default Condition
